// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qGkE","col":"styles_col__2hzZ7","actions":"styles_actions__zQDbD","conflict":"styles_conflict__1s2V8"};